function email(email) {
  const errorText = 'Email not valid';
  const onTypeError = !this.checkEmailValid(email);

  clearTimeout(this.validFlagId);
  this.validFlagId = null;
  this.emailError = null;

  if (!onTypeError) return;

  /* async */
  this.setAsyncInputError(errorText);
}

export { email };
